<template>
  <div class="c-app">
    <TheSidebar/>
    <CWrapper>
      <TheHeader/>
      <div class="c-body">
        <main class="c-main">
          <CContainer fluid>
            <transition name="fade">
              <router-view></router-view>
            </transition>
          </CContainer>
        </main>
      </div>
      <TheFooter/>
    </CWrapper>
  </div>
</template>

<script>
import TheSidebar from './TheSidebar'
import TheHeader from './TheHeader'
import TheFooter from './TheFooter'
import TheHeaderCustom from './TheHeaderCustom'
import TheHeaderStudentCustom from './TheHeaderStudentCustom'

export default {
  name: 'TheContainer',
  components: {
    TheSidebar,
    TheHeader,
    TheFooter,
    TheHeaderCustom,
    TheHeaderStudentCustom
  },
  data() {
    return {
      lastActivity: Date.now(),
    };
  },
  methods: {
    updateLastActivity() {
      this.lastActivity = Date.now();
    },
  },
  mounted() {
    document.addEventListener("mousemove", this.updateLastActivity);
    document.addEventListener("keypress", this.updateLastActivity);
  },
  beforeDestroy() {
    document.removeEventListener("mousemove", this.updateLastActivity);
    document.removeEventListener("keypress", this.updateLastActivity);
  },
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
